import axios from 'axios';

export const api = axios.create({
  baseURL: '/api/',
});

export const apiFiles = axios.create({
  baseURL: '/api/',
  headers: {
    'Content-Type': 'multipart/form-data',
    Accept: '*/*',
  },
});

export const apiPlain = axios.create({
  baseURL: '/api/',
  headers: {
    'Content-Type': 'text/plain',
  },
});
